"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
const client_sdk_common_1 = require("@easygenerator/client-sdk.common");
const base_analytics_provider_1 = require("./base-analytics-provider");
const EXPERIMENTAL_NATIVE_MIXPANEL_INTEGRATION_FEATURE_FLAG = 'experimental-native-mixpanel-integration';
class NativeMixpanelProvider extends base_analytics_provider_1.BaseAnalyticsProvider {
    constructor(config) {
        var _a;
        super();
        this.mixpanelInstance = mixpanel_browser_1.default;
        this.projectName = config.projectName;
        this.projectId = config.projectId;
        this.isPageViewTrackingDisabled = (_a = config.isPageViewTrackingDisabled) !== null && _a !== void 0 ? _a : true;
        client_sdk_common_1.FeatureFlagsProvider.featureFlags.on('update', this.featureFlagsUpdateHandler.bind(this));
        this.isNativeMixpanelIntegrationEnabled = client_sdk_common_1.FeatureFlagsProvider.featureFlags.isFeatureEnabled(EXPERIMENTAL_NATIVE_MIXPANEL_INTEGRATION_FEATURE_FLAG);
        this.initMixpanel();
    }
    performLogout() {
        var _a;
        (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.reset();
        client_sdk_common_1.FeatureFlagsProvider.featureFlags.off('update', this.featureFlagsUpdateHandler.bind(this));
    }
    initMixpanel() {
        if (!this.isNativeMixpanelIntegrationEnabled) {
            console.warn(`Native Mixpanel integration is disabled by feature flag`);
            return;
        }
        if (!this.isValidMixpanelConfig()) {
            console.warn('Mixpanel Project ID / Project name is not configured');
            return;
        }
        if (this.mixpanelInstance[this.projectName]) {
            this.isInitialized = true;
            return;
        }
        this.mixpanelInstance.init(this.projectId, {
            autocapture: false,
            record_sessions_percent: 0,
            persistence: 'localStorage',
            record_idle_timeout_ms: 300000,
            record_block_selector: '[data-grammarly-shadow-root]',
            api_host: 'https://api-eu.mixpanel.com'
        }, this.projectName);
        this.isInitialized = true;
    }
    isValidMixpanelConfig() {
        return Boolean(this.projectName && this.projectId);
    }
    featureFlagsUpdateHandler() {
        var _a;
        this.isNativeMixpanelIntegrationEnabled = client_sdk_common_1.FeatureFlagsProvider.featureFlags.isFeatureEnabled(EXPERIMENTAL_NATIVE_MIXPANEL_INTEGRATION_FEATURE_FLAG);
        if (this.isNativeMixpanelIntegrationEnabled && !this.isInitialized) {
            this.initMixpanel();
            if ((_a = this.identityData) === null || _a === void 0 ? void 0 : _a.id) {
                this.identifyUser(this.identityData);
            }
        }
        if (!this.isNativeMixpanelIntegrationEnabled) {
            this.logout();
        }
    }
    trackPage() {
        var _a;
        if (this.isPageViewTrackingDisabled) {
            return;
        }
        (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.track_pageview();
    }
    identifyUser(identity) {
        var _a, _b, _c;
        const { id, ...rest } = identity;
        (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.identify(id);
        (_c = (_b = this.mixpanelInstance[this.projectName]) === null || _b === void 0 ? void 0 : _b.people) === null || _c === void 0 ? void 0 : _c.set(rest);
    }
    track(eventName, properties) {
        var _a;
        (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.track(eventName, properties);
    }
    updateUserIdentity(id, userProps) {
        var _a, _b, _c;
        (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.identify(id);
        (_c = (_b = this.mixpanelInstance[this.projectName]) === null || _b === void 0 ? void 0 : _b.people) === null || _c === void 0 ? void 0 : _c.set(userProps);
    }
}
exports.default = NativeMixpanelProvider;
